// extracted by mini-css-extract-plugin
export default {"mainWrapper":"ForgotPassword_mainWrapper__mJoee"};